import { render, staticRenderFns } from "./ImageCollectionComponent.vue?vue&type=template&id=238ef596"
import script from "./ImageCollectionComponent.vue?vue&type=script&lang=js"
export * from "./ImageCollectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ImageCollectionComponent.vue?vue&type=style&index=0&id=238ef596&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports